const dynamicIp = process.env.REACT_APP_API_IP
const runtimeHostname = typeof window !== 'undefined' ? window.location.hostname : undefined
const developmentApiHost = process.env.REACT_APP_API_HOST || runtimeHostname || dynamicIp || 'localhost'

export const APP_API_URL = process.env.NODE_ENV === 'development'
    ? `http://${developmentApiHost}:5006/api`
    : 'https://crm.iktbox.ru/crm'